import { UI } from '../../modules/UI';
import { App } from '../../modules/App';
import { userManagementAccounts } from '../../modules/ReactComponent';
import { ValidationRules } from '../../modules/ValidationRules';
import './scss/settingsUser.scss';

export const SettingsUser = (function () {
  const handleIsEdit = (id, action = '') => id && Number(id) !== 0 && action === 'edit';
  let $selectedAccounts = {};

  const backToSettings = () => {
    UI.offPageLeaveHandler();
    $router.push(`/settings`);
  };

  let settingsUserFormSubmit = (event, callback = false) => {
    let $form = $('#settingUserDialogForm');
    let formData = $form.serializeObject();

    let isAccountsValid = true;

    if (!Array.isArray($selectedAccounts) || !$selectedAccounts.length) {
      isAccountsValid = false;
    }

    if (!$form.valid()) {
      UI.notify({
        text: $lang.settings.Errors.RequiredFieldsMissing,
        icon: 'fal fa-times-circle',
        type: 'danger'
      });
    }

    if (!isAccountsValid) {
      UI.notify({
        text: $lang.settings.Errors.AccountsRequired,
        icon: 'fal fa-times-circle',
        type: 'danger'
      });
    }

    if (!$form.valid() || !isAccountsValid) return false;

    // Selected User Group
    let userGroupsObj = $('[name="userGroups"]').select2('data')[0];
    formData.selectedUserGrop = { id: userGroupsObj.id, title: userGroupsObj.text };
    formData.selectedAccounts = $selectedAccounts;
    delete formData.userGroups;

    UI.block('#page');

    let url = formData.id ? `settings/user/update` : `settings/user/create`;
    $.when(App.ajaxData(url, formData, 'POST')) //Getting Brands list
      .done((res) => {
        if (res.isSuccess) {
          UI.notify({
            text: $lang.alert.SuccessfullySaved,
            icon: 'fal fa-check-circle',
            type: 'success'
          });

          if (callback) {
            callback(res);
          }

          backToSettings();
        }
      })
      .always((error) => {
        UI.unblock('#page');
      });
  };

  let formInit = (id) => {
    let $form = $('#settingUserDialogForm');
    let $passwordIcons = $('#settingUserDialogForm .js-toggle-show-pass');

    const switchPasswordHandler = (e) => {
      if (e.target?.classList?.contains('fa-eye-slash')) {
        e.target.classList.remove('fa-eye-slash');
        e.target.classList.add('fa-eye');
        e.target.parentNode.parentNode.parentNode.querySelector('input').type = 'text';
      } else if (e.target?.classList?.contains('fa-eye')) {
        e.target.classList.remove('fa-eye');
        e.target.classList.add('fa-eye-slash');
        e.target.parentNode.parentNode.parentNode.querySelector('input').type = 'password';
      }
    };
    if (!id) {
      $passwordIcons.removeClass('fa-eye-slash');
      $passwordIcons.addClass('fa-eye');
      $passwordIcons.each(function () {
        $(this).parent().parent().parent().find('input').attr('type', 'text');
      });
    }
    $passwordIcons.on('click', (e) => switchPasswordHandler(e));

    $('[name="userGroups"]', $form)
      .select2()
      .on('change', () => $form.valid());

    $form.validate({ rules: ValidationRules.userCreateFrom });
  };

  let init = (params, query) => {
    const id = params?.id;
    const isEdit = handleIsEdit(id, params?.action);

    let requestUrl = isEdit ? `/settings/users/${id}` : `/settings/emptyUser`;

    UI.block('#page');
    $.when(App.ajaxData(requestUrl))
      .done((res) => {
        if (res.isSuccess) {
          let pageData = {
            $lang: $lang,
            backpagename: $lang.settings.userManagement,
            backpagelink: '/settings',
            user: res.createdObject,
            isEdit: isEdit
          };

          let template = require('./tmpl/settingsUser.hbs');

          UI.page(template, pageData).then(() => {
            $('[name="userGroups"]').select2({
              placeholder: 'Select user group'
            });

            formInit(id);

            $selectedAccounts = res.createdObject?.selectedAccounts;

            const onChange = (selectedAccounts) => {
              $selectedAccounts = selectedAccounts;
            };

            const data = {
              shortAccounts: res.createdObject?.shortAccounts,
              selectedAccounts: res.createdObject?.selectedAccounts,
              onChange: onChange
            };

            userManagementAccounts.init('userManagementAccounts', data);

            $('.js-settingsUser-save').on('click', settingsUserFormSubmit);
            $('.js-settingsUser-cancel').on('click', (e) => backToSettings());
          });
        }
      })
      .always((error) => {
        UI.unblock('#page');
      });
  };

  return {
    init
  };
})();
